// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* New Right Page Styles */

.new-right-container {
    background-color: #000;
    min-height: 80vh;
    color: #fff;
    padding: 20px;
    font-family: 'Karla', sans-serif;
}

.tabs-container {
    display: flex;
    gap: 60px;
    margin-bottom: 30px;
    border-bottom: 1px solid #333;
    padding-bottom: 10px;
}

.tabs-container > div:first-child::-webkit-scrollbar {
    display: none;
}

.tab {
    cursor: pointer;
    color: #888;
    font-weight: 600;
    font-size: 18px;
    position: relative;
}

.tab.active {
    color: #fff;
    font-weight: 600;
}

.tab.active::after {
    content: "";
    position: absolute;
    bottom: -12px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #fff;
}

.row {
    display: flex;
    align-items: center;
    padding: 15px 0px;
    border-bottom: 1px solid #222;
    cursor: pointer;
    transition: background-color 0.2s;
}

.row:hover {
    background-color: #111;
}

.row-content {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    gap: 24px;
}

.right-content {
    display: flex;
    align-items: center;
    gap: 20px;
}

.right-content.row-actions {
    flex: 1 1;
    justify-content: flex-start;
    gap: 24px;
    min-width: 0;
}

.row-label.css-ahj2mt-MuiTypography-root {
    font-family: 'Karla', sans-serif;
    font-weight: 600;
    font-size: 18px;
    width: 220px;
    min-width: 220px;
    flex-shrink: 0;
}

.options-display {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    min-width: 0;
    flex: 1 1;
}

.options-text {
    font-family: 'Karla', sans-serif;
    font-weight: 500;
    font-size: 18px;
    flex: 1 1;
    min-width: 0;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 24px;
}


/* MUI Switch Override Styles (target standard MUI classes if needed, 
   but for the IOSSwitch specific logic, we might need to keep some in JS or use sx) */

.ios-switch {
    width: 40px !important;
    height: 20px !important;
    padding: 0 !important;
}

.ios-switch .MuiSwitch-switchBase {
    padding: 0 !important;
    margin: 2px !important;
    transition-duration: 300ms !important;
}

.ios-switch .MuiSwitch-switchBase.Mui-checked {
    transform: translateX(18px) !important;
    color: #fff !important;
}

.ios-switch .Mui-checked+.MuiSwitch-track {
    background-color: #50C878 !important;
    opacity: 1 !important;
    border: 0 !important;
}

.ios-switch .MuiSwitch-thumb {
    width: 16px !important;
    height: 16px !important;
    box-sizing: border-box !important;
}

.ios-switch .MuiSwitch-track {
    border-radius: 10px !important;
    background-color: #39393D !important;
    opacity: 1 !important;
    transition: background-color 500ms !important;
}

.no-data-msg {
    /* height: 300px; */
    display: flex;
    align-items: center;
    justify-content: center;
  }
   
  .no-data-card {
    background: linear-gradient(145deg, #111, #1a1a1a);
    border: 1px solid #2a2a2a;
    border-radius: 14px;
    padding: 28px 36px;
    text-align: center;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);
    animation: fadeUp 0.4s ease-in-out;
  }
   
  .no-data-icon {
    font-size: 42px;
    margin-bottom: 10px;
  }
   
  .no-data-title {
    font-size: 20px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 6px;
  }
   
  .no-data-text {
    font-size: 14px;
    color: #b3b3b3;
  }
   
  /* subtle animation */
  @keyframes fadeUp {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }`, "",{"version":3,"sources":["webpack://./src/features/Setting/New Rights/NewRightsPage.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;IACI,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,WAAW;IACX,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;IAC7B,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,2BAA2B;IAC3B,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,SAAO;AACX;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,SAAO;IACP,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;AACrB;;;AAGA;sFACsF;;AAEtF;IACI,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kDAAkD;IAClD,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA,qBAAqB;EACrB;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF","sourcesContent":["/* New Right Page Styles */\n\n.new-right-container {\n    background-color: #000;\n    min-height: 80vh;\n    color: #fff;\n    padding: 20px;\n    font-family: 'Karla', sans-serif;\n}\n\n.tabs-container {\n    display: flex;\n    gap: 60px;\n    margin-bottom: 30px;\n    border-bottom: 1px solid #333;\n    padding-bottom: 10px;\n}\n\n.tabs-container > div:first-child::-webkit-scrollbar {\n    display: none;\n}\n\n.tab {\n    cursor: pointer;\n    color: #888;\n    font-weight: 600;\n    font-size: 18px;\n    position: relative;\n}\n\n.tab.active {\n    color: #fff;\n    font-weight: 600;\n}\n\n.tab.active::after {\n    content: \"\";\n    position: absolute;\n    bottom: -12px;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background-color: #fff;\n}\n\n.row {\n    display: flex;\n    align-items: center;\n    padding: 15px 0px;\n    border-bottom: 1px solid #222;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.row:hover {\n    background-color: #111;\n}\n\n.row-content {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: space-between;\n    gap: 24px;\n}\n\n.right-content {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.right-content.row-actions {\n    flex: 1;\n    justify-content: flex-start;\n    gap: 24px;\n    min-width: 0;\n}\n\n.row-label.css-ahj2mt-MuiTypography-root {\n    font-family: 'Karla', sans-serif;\n    font-weight: 600;\n    font-size: 18px;\n    width: 220px;\n    min-width: 220px;\n    flex-shrink: 0;\n}\n\n.options-display {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n    min-width: 0;\n    flex: 1;\n}\n\n.options-text {\n    font-family: 'Karla', sans-serif;\n    font-weight: 500;\n    font-size: 18px;\n    flex: 1;\n    min-width: 0;\n    margin: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    line-height: 24px;\n}\n\n\n/* MUI Switch Override Styles (target standard MUI classes if needed, \n   but for the IOSSwitch specific logic, we might need to keep some in JS or use sx) */\n\n.ios-switch {\n    width: 40px !important;\n    height: 20px !important;\n    padding: 0 !important;\n}\n\n.ios-switch .MuiSwitch-switchBase {\n    padding: 0 !important;\n    margin: 2px !important;\n    transition-duration: 300ms !important;\n}\n\n.ios-switch .MuiSwitch-switchBase.Mui-checked {\n    transform: translateX(18px) !important;\n    color: #fff !important;\n}\n\n.ios-switch .Mui-checked+.MuiSwitch-track {\n    background-color: #50C878 !important;\n    opacity: 1 !important;\n    border: 0 !important;\n}\n\n.ios-switch .MuiSwitch-thumb {\n    width: 16px !important;\n    height: 16px !important;\n    box-sizing: border-box !important;\n}\n\n.ios-switch .MuiSwitch-track {\n    border-radius: 10px !important;\n    background-color: #39393D !important;\n    opacity: 1 !important;\n    transition: background-color 500ms !important;\n}\n\n.no-data-msg {\n    /* height: 300px; */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n   \n  .no-data-card {\n    background: linear-gradient(145deg, #111, #1a1a1a);\n    border: 1px solid #2a2a2a;\n    border-radius: 14px;\n    padding: 28px 36px;\n    text-align: center;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);\n    animation: fadeUp 0.4s ease-in-out;\n  }\n   \n  .no-data-icon {\n    font-size: 42px;\n    margin-bottom: 10px;\n  }\n   \n  .no-data-title {\n    font-size: 20px;\n    font-weight: 600;\n    color: #ffffff;\n    margin-bottom: 6px;\n  }\n   \n  .no-data-text {\n    font-size: 14px;\n    color: #b3b3b3;\n  }\n   \n  /* subtle animation */\n  @keyframes fadeUp {\n    from {\n      opacity: 0;\n      transform: translateY(10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
